import "../../assets/css/About.css";

const AboutComps = () => {
  return (
    <>
      <section id="about" className="about-section">
        <div className="back">
          <div className="container">
            <div className="row ">
              <div className="col-md-6 hero-content mt-auto mb-auto">
                <h1 className="fw-bold">BACKGROUND</h1>
                <div className="underline1 no-margin"></div>
                <div className="underline2 no-margin"></div>
                {/* <p className="">
              The Indonesian Young Scientist Association (IYSA) and
              Udayana University Jimbaran Bali, Indonesia, continue to
              strive to increase their role and contribution in the
              world of education, especially research by organizing a
              series of activities such as webinars on research,
              online research courses, as well as organizing national
              level research competitions and international, as an
              effort to help improve the competence of teachers in
              Indonesia and help develop quality innovative ideas for
              the advancement of teachers in particular and also their
              immediate environment.
            </p> */}
                <p>
                  By looking at the current development and knowledge of
                  children about science, inventions and innovations, especially in
                  the field of science, it requires us to know the extent of students’
                  insights, knowledge. Therefore, the Yayasan Prestasi Belia
                  Indonesia (YPBI) will hold an International competition called Bali
                  International Science Fair (BISF) as the right learning platform to
                  nurture our talented young inventors who are active, creative
                  and innovative. <br/><br/>
                  The Yayasan Prestasi Belia Indonesia (YPBI) is an institution
                  engaged in developing the potential, talents and creativity of
                  Indonesian students in non-scientific competitions and
                  competitions at home and abroad. Therefore, YPBI stands as a
                  form of our deep concern in providing opportunities for
                  Indonesia student in particular, to bring out the potential and
                  skills needed as well as a spirit of competition that builds within
                  them. We do this to create life improvements. Because we
                  believe that every student has potential that can be developed.
                </p>
              </div>
              <div className="col-md-6  hero-image text-center">
                <img
                  src="./assets/images/logo/kecak.png"
                  className="img-fluid"
                  alt="Kecak Dance"
                ></img>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutComps;
